import { z } from 'zod'
import { api } from './baseApi'

// Order types
export const OrderSchema = z.object({
  mezzaOrderId: z.string(),
  customerName: z.string(),
  customerImageUrl: z.string().nullable(),
  paidDate: z.string(),
  merchantName: z.string(),
  locationName: z.string(),
  subTotal: z.number(),
  tax: z.number(),
  tipAmount: z.number(),
  amount: z.number(),
  currency: z.string(),
  mezzaMemberId: z.string(),
  simpleIdentifier: z.string(),
  posGroupId: z.string().nullable().optional(),
  isTestOrder: z.boolean(),
  checkNumber: z.string().nullable().optional(),
  /** Toast - Integrated only: true when Mezza posted the payment onto the Toast check itself. */
  posPaymentPosted: z.boolean().nullable().optional(),
})

export type Order = z.infer<typeof OrderSchema>

// Request types
export interface OrdersRequestParams {
  pageSize?: number
  startAfterId?: string
  filters: {
    search?: string
    merchantName?: string
    locationName?: string
  }
  sortBy: string | null
  sortDirection: 'asc' | 'desc'
}

export interface OrdersResponse {
  items: Order[]
  hasMore: boolean
  lastId?: string
}

// Orders API implementation
export const ordersApi = {
  fetchOrders: async (params: OrdersRequestParams): Promise<OrdersResponse> => {
    const response = await api.get<OrdersResponse>('/merchant/orders/list', {
      params: {
        pageSize: params.pageSize,
        startAfterId: params.startAfterId,
      }
    })
    return response.data
  },
} 